export const ADDRESS_FIELDS = {
  ORGANISATION: "organisation",
  PROPERTY: "property",
  STREET: "street",
  LOCALITY: "locality",
  TOWN: "town",
  COUNTY: "county",
  POSTCODE: "postcode"
};